// One field of a captured label, rendered.
//
// A dash means the printer sent nothing for this field, which is ordinary - the
// observed label prints its batch number as underscores. Written in full ink,
// though, a column of dashes has exactly the same visual weight as a column of
// real values, and the eye scanning for a batch number has to read every row to
// find out which cells are empty.
//
// So the dash is dimmed and the value is not. That is the whole component: it
// exists so the rule is applied the same way in the table and the drawer,
// instead of being retyped at each of the dozen call sites that need it.

import { isBlank } from '../lib/format';

interface Props {
    value: string | null | undefined;
    /** Barcodes, device ids and bill numbers: strings read back character by
     *  character against a paper label, where a monospace face is the difference
     *  between checking a value and squinting at one. */
    mono?: boolean;
    /** Digits that sit in a column and get compared down it. */
    num?: boolean;
}

export default function Value({ value, mono = false, num = false }: Props) {
    if (isBlank(value)) return <span className="sb-dash">—</span>;

    const cls = [mono ? 'mono' : '', num ? 'num' : ''].filter(Boolean).join(' ');
    return cls ? <span className={cls}>{value}</span> : <>{value}</>;
}
